"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef, cloneElement } from "react";
const ForwardedTabWrapper = forwardRef(({ TabWrapper, tabWrapperProps, children, ...childrenProps }, ref) => {
  if (!children) return null;
  if (!TabWrapper) {
    return cloneElement(children, { ...childrenProps, ref });
  }
  return /* @__PURE__ */ jsx(TabWrapper, { ref, ...tabWrapperProps, children: cloneElement(children, { ...childrenProps }) });
});
ForwardedTabWrapper.displayName = "ForwardedTabWrapper";
export {
  ForwardedTabWrapper
};
